import { useMutation, useQueryClient } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import OpeningTime, { OPENING_TIME } from "../../OpeningTimes/OpeningTime";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";

export const useDeletePlantOpeningTime = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (openingTime: OpeningTime) =>
      axios.delete<number>(openingTimesUrls.openingTimeWithId(openingTime.Id)),
    onSuccess: async (_: AxiosResponse<number>, variables: OpeningTime) => {
      await queryClient.invalidateQueries(openingTimeWithIdQueryKey(variables.ParentId, "plants"));
      toast.success(deleteSuccessMessage(variables.ParentId, `${OPENING_TIME} for Plant`));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
